(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initTopStickyMenu(){
    var $ = jQuery;
    $('.m-topstickymenu').attr('scrollBefore',0);
    $('.m-topstickymenu').attr('barplace',0);

    $(window).scroll(function(){
        var scrollBefore = $('.m-topstickymenu').attr('scrollBefore');
        var scrollNow = $(window).scrollTop();
        var barPlacement = $('.m-topstickymenu').attr('barplace');
        var barHeight = $('.m-topstickymenu').outerHeight();
        var placeNow = parseInt(barPlacement) + parseInt(scrollNow) - parseInt(scrollBefore);
        //console.log(placeNow);
        
        if(placeNow > barHeight){placeNow = barHeight;}
        if(placeNow < 0){placeNow = 0;}
        if(scrollNow < barHeight){placeNow = 0;}

        $('.m-topstickymenu').attr('scrollBefore',scrollNow);
        $('.m-topstickymenu').attr('barplace',placeNow);
        $('.m-topstickymenu,.m-sharebox .sharebox').css('transform','translateY(-'+placeNow+'px)');
    })
}